import LeadForm from './LeadForm';
import PageMeta from './PageMeta';
import {
  RedesignFooter,
  RedesignHeader,
  RedesignPage,
  SiteLink,
} from './RedesignShell';

const serviceGroups = [
  {
    title: 'Разработка сайтов',
    href: 'https://fatalitystudio.ru/services/websites/',
    text: 'Создаем сайты под задачи бизнеса с учетом SEO и конверсии.',
    items: [
      ['Корпоративные сайты', 'https://fatalitystudio.ru/services/websites/corporate/', 'Разработка сайтов для компаний с продуманной структурой и дизайном.'],
      ['Лендинги', 'https://fatalitystudio.ru/services/websites/landing/', 'Посадочные страницы для рекламы и лидогенерации.'],
      ['Интернет-магазины', 'https://fatalitystudio.ru/services/websites/ecommerce/', 'Разработка eCommerce проектов с удобной навигацией.'],
      ['Разработка под SEO', 'https://fatalitystudio.ru/services/websites/seo/', 'Создание сайтов с учетом требований поисковых систем.'],
      ['Сайт под ключ', 'https://fatalitystudio.ru/services/websites/service-business/', 'Полный цикл разработки сайта.'],
      ['Сайты услуг', 'https://fatalitystudio.ru/services/websites/service-business/', 'Решения для бизнеса с фокусом на заявки.'],
      ['Редизайн и поддержка', 'https://fatalitystudio.ru/services/websites/redesign-support/', 'Обновление сайта и улучшение его эффективности.'],
      ['Проверка сайта для РКН', 'https://fatalitystudio.ru/services/websites/rkn-check/', 'Аудит сайта на соответствие требованиям законодательства.'],
    ],
  },
  {
    title: 'Разработка приложений',
    href: 'https://fatalitystudio.ru/services/mobile/',
    text: 'Создаем мобильные и веб-приложения для бизнеса.',
    items: [
      ['MVP разработка', 'https://fatalitystudio.ru/services/mobile/mvp/', 'Запуск минимального продукта для тестирования идеи.'],
      ['iOS приложения', 'https://fatalitystudio.ru/services/mobile/ios/', 'Разработка приложений для Apple устройств.'],
      ['Android приложения', 'https://fatalitystudio.ru/services/mobile/android/', 'Создание приложений для Android.'],
      ['Интеграции', 'https://fatalitystudio.ru/services/mobile/integrations/', 'Интеграция CRM, API и сторонних сервисов.'],
      ['Публикация приложений', 'https://fatalitystudio.ru/services/mobile/publishing/', 'Размещение приложений в App Store и Google Play.'],
      ['ASO-продвижение', 'https://fatalitystudio.ru/services/mobile/aso/', 'Оптимизация приложений в сторах.'],
    ],
  },
  {
    title: 'Разработка Mini Apps и ботов',
    href: 'https://fatalitystudio.ru/services/mini-apps/',
    text: 'Создаем современные digital решения внутри экосистем.',
    items: [
      ['Telegram Mini App', 'https://fatalitystudio.ru/services/mini-apps/telegram/', 'Разработка приложений внутри Telegram.'],
      ['VK Mini App', 'https://fatalitystudio.ru/services/mini-apps/vk/', 'Создание приложений для ВКонтакте.'],
      ['Max Mini App', 'https://fatalitystudio.ru/services/mini-apps/max/', 'Разработка приложений под платформу Max.'],
      ['Боты и чат-боты', 'https://fatalitystudio.ru/services/mini-apps/bots/', 'Автоматизация общения с клиентами.'],
      ['Поддержка Mini Apps', 'https://fatalitystudio.ru/services/mini-apps/support/', 'Обслуживание и развитие приложений.'],
    ],
  },
  {
    title: 'SEO услуги и продвижение',
    href: 'https://fatalitystudio.ru/services/seo/',
    text: 'Продвигаем сайты и увеличиваем поток клиентов.',
    items: [
      ['SEO под ключ', 'https://fatalitystudio.ru/services/seo/full-cycle/', 'Комплексное продвижение сайтов.'],
      ['SEO аудит', 'https://fatalitystudio.ru/services/seo/audit/', 'Анализ и поиск точек роста.'],
      ['Техническое SEO', 'https://fatalitystudio.ru/services/seo/technical/', 'Исправление ошибок и оптимизация сайта.'],
      ['Внутренняя оптимизация', 'https://fatalitystudio.ru/services/seo/internal/', 'Работа с контентом и структурой сайта.'],
      ['Внешнее продвижение', 'https://fatalitystudio.ru/services/seo/external/', 'Работа со ссылками и репутацией.'],
    ],
  },
  {
    title: 'Продвижение и маркетинг',
    href: 'https://fatalitystudio.ru/services/yandex-maps/',
    text: 'Дополнительные инструменты для роста бизнеса.',
    items: [
      ['Продвижение в Яндекс.Картах', 'https://fatalitystudio.ru/services/yandex-maps/', 'Увеличение локального трафика и заявок.'],
    ],
  },
];

const benefits = [
  'digital агентство полного цикла',
  'опыт работы с бизнесом и крупными компаниями',
  'команда профессионалов digital студии',
  'успешные кейсы веб студии',
  'комплексные digital решения под ключ',
  'прозрачные процессы и отчетность',
];

const portfolioItems = [
  'создание сайтов и приложений',
  'SEO продвижение',
  'редизайн и развитие проектов',
];

function BulletList({ items }) {
  return (
    <ul className="source-list">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

function SectionHeader({ title, description, dark = false }) {
  return (
    <div className={`sec-head${dark ? ' ink-head' : ''}`}>
      <div>
        <h2>{title}</h2>
      </div>
      {description && <p className="sub">{description}</p>}
    </div>
  );
}

function AllServicesPage() {
  return (
    <RedesignPage>
      <PageMeta
        title="Услуги digital агентства в Москве — разработка сайтов, SEO, приложения"
        description="Digital агентство полного цикла: разработка сайтов и приложений, SEO продвижение, редизайн, поддержка и комплексные цифровые решения для бизнеса"
      />
      <RedesignHeader />

      <section className="ink service-hero">
        <div
          className="glow"
          style={{ right: '-360px', top: '-340px', width: '980px', height: '980px', opacity: 0.1 }}
        />
        <div className="container service-hero-grid">
          <div>
            <h1>Услуги digital агентства полного цикла</h1>
            <p className="hero-sub">Fatality Studio — это digital агентство в Москве, которое предоставляет комплексные цифровые решения для бизнеса.</p>
            <p className="service-hero-copy">Мы работаем как веб студия полного цикла и закрываем все задачи: разработка сайтов, создание приложений, SEO продвижение и техническая поддержка.</p>
            <p className="service-hero-copy">Наша команда помогает компаниям запускать проекты, развивать их и масштабировать в digital-среде.</p>
          </div>
          <div className="service-hero-panel" aria-label="Услуги digital агентства полного цикла">
            {serviceGroups.map((group, index) => (
              <SiteLink href={group.href} className="panel-line" key={group.title}>
                <span>{String(index + 1).padStart(2, '0')}</span>
                <b>{group.title}</b>
              </SiteLink>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            title="Комплексные digital услуги для бизнеса"
            description="Мы не просто оказываем отдельные услуги — мы выстраиваем системную работу над проектом."
          />
          <div className="split-proof">
            <div>
              <p>Как digital агентство полного цикла, мы объединяем:</p>
              <BulletList
                items={[
                  'разработку сайтов и приложений',
                  'SEO продвижение',
                  'UX/UI дизайн и редизайн',
                  'поддержку и обслуживание сайтов',
                ]}
              />
            </div>
            <div>
              <p>Это позволяет бизнесу получать результат быстрее и эффективнее.</p>
              <p>
                Заказать digital услуги - <SiteLink href="https://fatalitystudio.ru/contacts/" className="link-flat">здесь</SiteLink>
              </p>
            </div>
          </div>
        </div>
      </section>

      {serviceGroups.map((group, groupIndex) => (
        <section className={`${groupIndex % 2 ? 'ink' : 'canvas'} sec-pad section-line-top`} key={group.title}>
          <div className="container">
            <SectionHeader
              dark={Boolean(groupIndex % 2)}
              title={group.href ? <SiteLink href={group.href} className="link-flat">{group.title}</SiteLink> : group.title}
              description={group.text}
            />
            <div className="svc-grid website-type-grid">
              {group.items.map(([title, href, text], index) => (
                <SiteLink href={href} className="svc" key={title}>
                  <div className="svc-top">
                    <div className="svc-num">{String(index + 1).padStart(2, '0')}</div>
                    <div className="svc-arrow">↗</div>
                  </div>
                  <h3>{title}</h3>
                  <p>{text}</p>
                </SiteLink>
              ))}
            </div>
          </div>
        </section>
      ))}

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader title="Почему выбирают наше digital агентство" />
          <div className="compact-card-grid">
            {benefits.map((item, index) => (
              <div className="compact-card" key={item}>
                <div className="compact-num">{String(index + 1).padStart(2, '0')}</div>
                <p>{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader dark title="Кейсы и портфолио" description="В портфолио нашего digital агентства — десятки успешных проектов." />
          <div className="split-proof">
            <div>
              <p>Мы реализуем:</p>
              <BulletList items={portfolioItems} />
            </div>
            <div>
              <p>
                Смотреть все  кейсы - <SiteLink href="https://fatalitystudio.ru/portfolio/" className="link-flat">здесь</SiteLink>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="ink lead" id="all-services-lead">
        <div
          className="glow"
          style={{ left: '-300px', top: '-200px', width: '700px', height: '700px', opacity: 0.1 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <div className="lead-grid">
            <div className="lead-side">
              <h2 className="lead-heading">Заказать услуги digital агентства</h2>
              <p className="lead-text">Оставьте заявку — мы подберем оптимальное решение под задачи вашего бизнеса.</p>
              <p className="lead-text">Мы поможем реализовать проект, увеличить трафик и вывести бизнес на новый уровень.</p>
            </div>
            <LeadForm
              formId="all-services-lead-form"
              idPrefix="all-services"
              contactLabel="Телефон"
              contactType="tel"
              contactPlaceholder="+7 (___) ___-__-__"
              submitLabel="Оставить заявку"
              taskPlaceholder="Опишите задачу"
            />
          </div>
        </div>
      </section>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default AllServicesPage;
